const GetLogo = () => {
  let logo = document.location.pathname.split("/").slice(-1)[0].trim();
  if (!logo) {
    logo = "shs";
  }

  let color = "#0a213c";
  let banner = 0;
  let helpColor = "#fff";

  switch (logo) {
    case "ssi":
      color = "#cccccc";
      banner = 1;
      helpColor = "#000";
      break;
    case "sga":
      color = "#cccccc";
      banner = 2;
      helpColor = "#000";
      break;
    case "amps":
      color = "#cccccc";
      banner = 3;
      helpColor = "#000";
      break;
  }

  return {
    logo: logo,
    color: color,
    banner: banner,
    helpColor: helpColor,
  };
};

export default GetLogo;
